// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Checkbox-module__root--WbTnL {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #1a1a1a;
  cursor: pointer;
}

.Checkbox-module__input--Xo_C8 {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  margin: -1px;
  clip: rect(0, 0, 0, 0);
  clip-path: inset(50%);
  overflow: hidden;
  white-space: nowrap;
}

.Checkbox-module__indicator--n2onw {
  position: relative;
  box-sizing: border-box;
  display: inline-flex;
  width: 22px;
  height: 22px;
  flex: 0 0 22px;
  align-items: center;
  justify-content: center;
  border: 1px solid #bdb7ae;
  border-radius: 4px;
  background-color: #fff;
}

.Checkbox-module__input--Xo_C8:checked + .Checkbox-module__indicator--n2onw {
  border-color: #1a1a1a;
  background-color: #1a1a1a;
}

.Checkbox-module__input--Xo_C8:checked + .Checkbox-module__indicator--n2onw::after {
  width: 8px;
  height: 4px;
  border-bottom: 2px solid #fff;
  border-left: 2px solid #fff;
  content: '';
  transform: translateY(-1px) rotate(-45deg);
}

.Checkbox-module__input--Xo_C8:focus-visible + .Checkbox-module__indicator--n2onw {
  outline: 2px solid #1a1a1a;
  outline-offset: 2px;
}

.Checkbox-module__root--WbTnL:has(.Checkbox-module__input--Xo_C8:disabled) {
  cursor: not-allowed;
  opacity: 0.45;
}

.Checkbox-module__label--aWHgk {
  font: inherit;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Checkbox/Checkbox.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,SAAS;EACT,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,6BAA6B;EAC7B,2BAA2B;EAC3B,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;AACf","sourcesContent":[".root {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: #1a1a1a;\n  cursor: pointer;\n}\n\n.input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  border: 0;\n  margin: -1px;\n  clip: rect(0, 0, 0, 0);\n  clip-path: inset(50%);\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.indicator {\n  position: relative;\n  box-sizing: border-box;\n  display: inline-flex;\n  width: 22px;\n  height: 22px;\n  flex: 0 0 22px;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #bdb7ae;\n  border-radius: 4px;\n  background-color: #fff;\n}\n\n.input:checked + .indicator {\n  border-color: #1a1a1a;\n  background-color: #1a1a1a;\n}\n\n.input:checked + .indicator::after {\n  width: 8px;\n  height: 4px;\n  border-bottom: 2px solid #fff;\n  border-left: 2px solid #fff;\n  content: '';\n  transform: translateY(-1px) rotate(-45deg);\n}\n\n.input:focus-visible + .indicator {\n  outline: 2px solid #1a1a1a;\n  outline-offset: 2px;\n}\n\n.root:has(.input:disabled) {\n  cursor: not-allowed;\n  opacity: 0.45;\n}\n\n.label {\n  font: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Checkbox-module__root--WbTnL`,
	"input": `Checkbox-module__input--Xo_C8`,
	"indicator": `Checkbox-module__indicator--n2onw`,
	"label": `Checkbox-module__label--aWHgk`
};
export default ___CSS_LOADER_EXPORT___;
